import React, { useState, useEffect } from 'react';
import { db, auth } from '../../firebase';
import { ref, onValue } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import InchargeLayout from './InchargeLayout';
import {
    FaSearch,
    FaIdCard,
    FaFileAlt,
    FaTrash,
    FaPrint,
    FaFileExcel,
    FaCopy,
    FaStamp,
    FaMoneyBillWave,
    FaUserTie,
    FaArrowLeft
} from 'react-icons/fa';

const MainviewOpenForm = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [registrations, setRegistrations] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (!user) navigate('/login');
        });

        // Fetching data from EngineerRegistrations or a dedicated OpenApplications node
        // Based on the 'Open Application' category in the dashboard
        const registrationsRef = ref(db, 'ekamwatapzp/EngineerRegistrations');
        const unsubData = onValue(registrationsRef, (snapshot) => {
            let list = [];
            if (snapshot.exists()) {
                const dataObj = snapshot.val();
                list = Object.keys(dataObj).map(key => ({
                    id: key,
                    ...dataObj[key]
                }));
            }

            // Dummy Data to match the provided image and expansion
            const dummyData = [
                { id: '1', firstName: 'अक्षय बाळू', surname: 'सावंत', whatsappNo: '9876543210', submittedAt: '10-Mar-2026', assistantStatus: 'Pending', firmName: 'Sawant Constructions', firmAddress: 'Thane West', panNo: 'ABCDE1234F', category: 'अ', eligibility: '50 लक्ष' },
                { id: '2', firstName: 'विश्वास यशवंत', surname: 'भंडीवले', whatsappNo: '9168832567', submittedAt: '08-Feb-2026', assistantStatus: 'Pending', firmName: 'Bhandivale Builders', firmAddress: 'Kalyan' },
                { id: '3', firstName: 'ओंकार अशोक', surname: 'जाधव', whatsappNo: '8329836484', submittedAt: '12-Oct-2025', assistantStatus: 'Pending', firmName: 'Jadhav Enterprises', firmAddress: 'Bhiwandi' },
                { id: '4', firstName: 'Manish Krushna', surname: 'Pawar', whatsappNo: '9011173580', submittedAt: '17-Sep-2025', assistantStatus: 'Pending', firmName: 'Pawar Infra', firmAddress: 'Shahapur' },
                { id: '5', firstName: 'किशोर दामू', surname: 'पाटील', whatsappNo: '9594077749', submittedAt: '14-Jul-2025', assistantStatus: 'Rejected', firmName: 'Patil Services', firmAddress: 'Murbad' },
                { id: '6', firstName: 'गणेश वाळकू', surname: 'घावट', whatsappNo: '8691936576', submittedAt: '22-Mar-2025', assistantStatus: 'Rejected', firmName: 'Ghavat Traders', firmAddress: 'Ambernath' },
                { id: '7', firstName: 'सुनील रामा', surname: 'देशमुख', whatsappNo: '9001122334', submittedAt: '01-Jan-2026', assistantStatus: 'Approved', firmName: 'Deshmukh & Co', firmAddress: 'Ulhasnagar' },
                { id: '8', firstName: 'राकेश विनायक', surname: 'शिंदे', whatsappNo: '8877665544', submittedAt: '15-Dec-2025', assistantStatus: 'Approved', firmName: 'Shinde Associates', firmAddress: 'Thane City' },
                { id: '9', firstName: 'संदीप मारुती', surname: 'मोरे', whatsappNo: '7766554422', submittedAt: '20-Nov-2025', assistantStatus: 'Pending', firmName: 'More Projects', firmAddress: 'Titwala' },
                { id: '10', firstName: 'दिपक पांडुरंग', surname: 'भोईर', whatsappNo: '9988776655', submittedAt: '05-Oct-2025', assistantStatus: 'Pending', firmName: 'Bhoir Group', firmAddress: 'Dombivli' },
                { id: '11', firstName: 'अमोल विठ्ठल', surname: 'गायकवाड', whatsappNo: '9822334455', submittedAt: '18-Sep-2025', assistantStatus: 'Rejected', firmName: 'Gaikwad Constro', firmAddress: 'Badlapur' },
                { id: '12', firstName: 'विकास लक्ष्मण', surname: 'कदम', whatsappNo: '9011002233', submittedAt: '10-Aug-2025', assistantStatus: 'Approved', firmName: 'Kadam Builders', firmAddress: 'Shirgaon' },
                { id: '13', firstName: 'सौरभ रमेश', surname: 'पाटील', whatsappNo: '8844556677', submittedAt: '30-Jul-2025', assistantStatus: 'Pending', firmName: 'Patil Heights', firmAddress: 'Vasind' },
                { id: '14', firstName: 'नितीन दत्तात्रय', surname: 'साळुंखे', whatsappNo: '9677889900', submittedAt: '12-Jun-2025', assistantStatus: 'Pending', firmName: 'Salunkhe Works', firmAddress: 'Khadavali' },
                { id: '15', firstName: 'विजय अर्जुन', surname: 'चव्हाण', whatsappNo: '8100223344', submittedAt: '05-May-2025', assistantStatus: 'Approved', firmName: 'Chavan Estates', firmAddress: 'Padgha' }
            ];

            const combinedList = [...list, ...dummyData];
            setRegistrations(combinedList);
            setLoading(false);
        });

        return () => {
            unsubscribe();
            unsubData();
        };
    }, [navigate]);

    const filteredData = registrations.filter(item => {
        const fullName = `${item.firstName || ''} ${item.surname || ''}`.toLowerCase();
        const phone = (item.whatsappNo || '').toString();
        const search = searchTerm.toLowerCase();
        return fullName.includes(search) || phone.includes(search);
    });

    const getStatusStyle = (status) => {
        const s = (status || 'Pending').toLowerCase();
        if (s === 'approved' || s === 'accepted') return 'text-emerald-600 font-bold';
        if (s === 'rejected') return 'text-rose-600 font-bold';
        return 'text-amber-500 font-bold';
    };

    return (
        <InchargeLayout>
            <div className="min-h-screen bg-gray-50 flex flex-col ">
                {/* Header Section */}
                <div className="bg-white border-b border-gray-200 px-6 py-4 flex flex-col md:flex-row md:items-center justify-between gap-4 shadow-sm">
                    <div className="flex items-center gap-4">
                        <button
                            onClick={() => navigate(-1)}
                            className="p-2.5 bg-white border border-gray-200 rounded-xl text-gray-400 hover:text-blue-600 hover:border-blue-100 hover:bg-blue-50 transition-all shadow-sm group"
                        >
                            <FaArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform" />
                        </button>
                        <h1 className="text-xl font-bold text-gray-800 tracking-tight">ओपन ॲप्लिकेशन यादी</h1>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-gray-500">
                        <span>सांगली जिल्हा परिषद</span>
                        <span className="text-gray-400">/</span>
                        <span className="font-medium text-gray-600">ओपन ॲप्लिकेशन यादी</span>
                    </div>
                </div>

                <div className="p-4 md:p-8">
                    {/* Status Legend Section */}
                    <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-end items-center gap-6 mb-4 text-xs font-bold text-gray-600">
                        <div className="flex items-center gap-4">
                            <div className="flex items-center gap-1.5"><span className="w-3 h-3 rounded-full bg-amber-500"></span> निलंबन</div>
                            <div className="flex items-center gap-1.5"><span className="w-3 h-3 rounded-full bg-emerald-500"></span> मंजूर</div>
                            <div className="flex items-center gap-1.5"><span className="w-3 h-3 rounded-full bg-rose-500"></span> नाकारले</div>
                        </div>
                        <div className="flex flex-wrap items-center gap-x-5 gap-y-2 opacity-80">
                            <div className="flex items-center gap-1.5"><FaUserTie className="text-gray-400" /> अर्जदाराची संपूर्ण माहिती</div>
                            <div className="flex items-center gap-1.5"><FaFileAlt className="text-gray-400" /> अर्जदाराची कागदपत्रे</div>
                            <div className="flex items-center gap-1.5"><FaTrash className="text-gray-400" /> डिलीट</div>
                            <div className="flex items-center gap-1.5"><FaMoneyBillWave className="text-gray-400" /> चलन अपलोड केले</div>
                        </div>
                    </div>

                    <div className="max-w-7xl mx-auto bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden p-6 md:p-8">

                        {/* Action Buttons & Search */}
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
                            <div className="flex items-center gap-0.5">
                                <button className="bg-gray-600 hover:bg-gray-700 text-white px-5 py-2.5 text-xs font-bold uppercase tracking-widest transition-colors first:rounded-l-lg">
                                    Copy
                                </button>
                                <button className="bg-gray-600 hover:bg-gray-700 text-white px-5 py-2.5 text-xs font-bold uppercase tracking-widest transition-colors border-l border-gray-500">
                                    Excel
                                </button>
                                <button className="bg-gray-600 hover:bg-gray-700 text-white px-5 py-2.5 text-xs font-bold uppercase tracking-widest transition-colors last:rounded-r-lg border-l border-gray-500">
                                    Print
                                </button>
                            </div>

                            <div className="flex items-center gap-3">
                                <label className="text-sm font-bold text-gray-400 italic">Search:</label>
                                <div className="relative group">
                                    <input
                                        type="text"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        className="border border-gray-200 rounded-lg px-4 py-2 text-sm outline-none focus:ring-4 focus:ring-blue-500/10 focus:border-blue-400 transition-all w-48 md:w-64 bg-gray-50/50"
                                    />
                                    <FaSearch className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-300 group-focus-within:text-blue-400 transition-colors" />
                                </div>
                            </div>
                        </div>

                        {/* Table */}
                        <div className="overflow-x-auto border border-gray-50 rounded-xl">
                            <table className="w-full text-left text-sm italic">
                                <thead>
                                    <tr className="bg-white text-gray-500 border-b border-gray-100">
                                        <th className="px-5 py-5 font-bold text-[11px] uppercase tracking-widest border-r border-gray-50 w-20 text-center">क्र.</th>
                                        <th className="px-5 py-5 font-bold text-[11px] uppercase tracking-widest border-r border-gray-50 w-1/3">अर्जदाराचे नाव</th>
                                        <th className="px-5 py-5 font-bold text-[11px] uppercase tracking-widest border-r border-gray-50">फोन क्र.</th>
                                        <th className="px-5 py-5 font-bold text-[11px] uppercase tracking-widest border-r border-gray-50">नोंदणी दिनांक</th>
                                        <th className="px-5 py-5 font-bold text-[11px] uppercase tracking-widest border-r border-gray-50">Assistant Status</th>
                                        <th className="px-5 py-5 font-bold text-[11px] uppercase tracking-widest text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-50">
                                    {loading ? (
                                        <tr>
                                            <td colSpan="6" className="px-6 py-12 text-center text-gray-300 font-bold tracking-widest animate-pulse uppercase">लोड होत आहे...</td>
                                        </tr>
                                    ) : filteredData.length > 0 ? (
                                        filteredData.map((item, index) => (
                                            <tr key={item.id} className="hover:bg-blue-50/30 transition-all group">
                                                <td className="px-5 py-6 border-r border-gray-50 text-center font-bold text-gray-700">
                                                    {index + 1}
                                                </td>
                                                <td className="px-5 py-6 border-r border-gray-50 text-gray-700 font-bold">
                                                    {item.firstName} {item.surname}
                                                </td>
                                                <td className="px-5 py-6 border-r border-gray-50 text-gray-600 font-bold">
                                                    {item.whatsappNo}
                                                </td>
                                                <td className="px-5 py-6 border-r border-gray-50 text-gray-600 font-bold">
                                                    {item.submittedAt}
                                                </td>
                                                <td className={`px-5 py-6 border-r border-gray-50 ${getStatusStyle(item.assistantStatus)}`}>
                                                    {item.assistantStatus}
                                                </td>
                                                <td className="px-5 py-6">
                                                    <div className="flex items-center justify-center gap-4 text-gray-400">
                                                        <button
                                                            onClick={() => navigate('/main-view-open-application-form', { state: { userData: item } })}
                                                            className="hover:text-blue-600 transition-colors"
                                                            title="संपूर्ण माहिती"
                                                        >
                                                            <FaUserTie size={16} />
                                                        </button>
                                                        <button
                                                            onClick={() => navigate('/main-new-open-status', { state: { userData: item } })}
                                                            className="hover:text-emerald-600 transition-colors"
                                                            title="कागदपत्रे"
                                                        >
                                                            <FaFileAlt size={16} />
                                                        </button>
                                                        <button className="hover:text-rose-600 transition-colors" title="डिलीट">
                                                            <FaTrash size={15} />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="px-6 py-16 text-center text-gray-400 font-bold tracking-widest uppercase">
                                                कोणताही डेटा सापडला नाही
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination Summary */}
                        <div className="mt-8 pt-8 border-t border-gray-50 text-gray-400 text-xs font-bold tracking-widest uppercase ">
                            Showing {filteredData.length > 0 ? 1 : 0} to {filteredData.length} of {filteredData.length} entries
                        </div>

                    </div>

                    {/* Copyright footer */}
                    <div className="mt-12 text-center pb-8 opacity-40">
                        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest italic">
                            © 2026 Thane Zilla Parishad. All Rights Reserved. <br /> Open Application Management Module.
                        </p>
                    </div>
                </div>
            </div>
        </InchargeLayout>
    );
};

export default MainviewOpenForm;
